import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./CSS/energy.css";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_energy_tags2,
  set_tag_values,
  set_external_trend_info,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let state_2 = [
  {
    "LOBİ PANOSU": [
      { text: "Tüketim", tagId: "248" },
      { text: "Güç", tagId: "243" },
      { text: "L1 Gerilim", tagId: "228" },
      { text: "L2 Gerilim", tagId: "236" },
      { text: "L3 Gerilim", tagId: "237" },
      { text: "L1 Akım", tagId: "238" },
      { text: "L2 Akım", tagId: "239" },
      { text: "L3 Akım", tagId: "240" },
      { text: "Güç Faktörü", tagId: "242" },
      { text: "Reaktif Güç ", tagId: "244" },
      { text: "Frekans", tagId: "246" },
    ],
  },
  {
    "YAKIT POMPASI": [
      { text: "Tüketim", tagId: "332" },
      { text: "Güç", tagId: "327" },
      { text: "L1 Gerilim", tagId: "312" },
      { text: "L2 Gerilim", tagId: "320" },
      { text: "L3 Gerilim", tagId: "321" },
      { text: "L1 Akım", tagId: "322" },
      { text: "L2 Akım", tagId: "323" },
      { text: "L3 Akım", tagId: "324" },
      { text: "Güç Faktörü", tagId: "326" },
      { text: "Reaktif Güç ", tagId: "328" },
      { text: "Frekans", tagId: "330" },
    ],
  },
  {
    "YATAK KATLARI": [
      { text: "Tüketim", tagId: "353" },
      { text: "Güç", tagId: "348" },
      { text: "L1 Gerilim", tagId: "333" },
      { text: "L2 Gerilim", tagId: "341" },
      { text: "L3 Gerilim", tagId: "342" },
      { text: "L1 Akım", tagId: "343" },
      { text: "L2 Akım", tagId: "344" },
      { text: "L3 Akım", tagId: "345" },
      { text: "Güç Faktörü", tagId: "347" },
      { text: "Reaktif Güç ", tagId: "349" },
      { text: "Frekans", tagId: "351" },
    ],
  },
  {
    "REZERVASYON OFİS": [
      { text: "Tüketim", tagId: "374" },
      { text: "Güç", tagId: "369" },
      { text: "L1 Gerilim", tagId: "354" },
      { text: "L2 Gerilim", tagId: "362" },
      { text: "L3 Gerilim", tagId: "363" },
      { text: "L1 Akım", tagId: "364" },
      { text: "L2 Akım", tagId: "365" },
      { text: "L3 Akım", tagId: "366" },
      { text: "Güç Faktörü", tagId: "368" },
      { text: "Reaktif Güç ", tagId: "370" },
      { text: "Frekans", tagId: "372" },
    ],
  },
  {
    "CAFE SHAKESPEARE": [
      { text: "Tüketim", tagId: "395" },
      { text: "Güç", tagId: "390" },
      { text: "L1 Gerilim", tagId: "375" },
      { text: "L2 Gerilim", tagId: "383" },
      { text: "L3 Gerilim", tagId: "384" },
      { text: "L1 Akım", tagId: "385" },
      { text: "L2 Akım", tagId: "386" },
      { text: "L3 Akım", tagId: "387" },
      { text: "Güç Faktörü", tagId: "389" },
      { text: "Reaktif Güç ", tagId: "391" },
      { text: "Frekans", tagId: "393" },
    ],
  },
  {
    FORFUN: [
      { text: "Tüketim", tagId: "416" },
      { text: "Güç", tagId: "411" },
      { text: "L1 Gerilim", tagId: "396" },
      { text: "L2 Gerilim", tagId: "404" },
      { text: "L3 Gerilim", tagId: "405" },
      { text: "L1 Akım", tagId: "406" },
      { text: "L2 Akım", tagId: "407" },
      { text: "L3 Akım", tagId: "408" },
      { text: "Güç Faktörü", tagId: "410" },
      { text: "Reaktif Güç ", tagId: "412" },
      { text: "Frekans", tagId: "414" },
    ],
  },
  {
    "BAŞKA OL CAFE": [
      { text: "Tüketim", tagId: "437" },
      { text: "Güç", tagId: "432" },
      { text: "L1 Gerilim", tagId: "417" },
      { text: "L2 Gerilim", tagId: "425" },
      { text: "L3 Gerilim", tagId: "426" },
      { text: "L1 Akım", tagId: "427" },
      { text: "L2 Akım", tagId: "428" },
      { text: "L3 Akım", tagId: "429" },
      { text: "Güç Faktörü", tagId: "431" },
      { text: "Reaktif Güç ", tagId: "433" },
      { text: "Frekans", tagId: "435" },
    ],
  },
];
const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/energy2") {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(obj2__),
            }
          );
          const response = await request.json();

          const roundedResponse = response.map((item) => ({
            ...item,
            tag_value: parseFloat(item.tag_value).toFixed(2),
          }));

          Store.dispatch(set_energy_tags2(roundedResponse));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 3500);
};

setTimeout(() => {
  inital_func();
}, 1000);

const Energy2 = (props) => {
  const [tag_values, Set_tag_values] = useState([]);
  const history = useHistory();
  const [state, SetState] = useState(state_2);

  const maxValueByType = {
    "L1 Gerilim": 240,
    "L2 Gerilim": 240,
    "L3 Gerilim": 240,
    "L1 Akım": 250,
    "L2 Akım": 250,
    "L3 Akım": 250,
  };
  const minValueByType = {
    "L1 Gerilim": 210,
    "L2 Gerilim": 210,
    "L3 Gerilim": 210,
  };

  useEffect(() => {
    Set_tag_values(props.tag_values);
    console.log(props.tag_values);
  }, [props.tag_values]);

  useEffect(() => {
    console.log(
      "111111111111222222222222233333333333333333444444444444444444444555555555555555555555555555555555666666666666666666666666666"
    );

    const componentDidMount = () => {
      var obj__ = [];
      var obj2__ = [];

      state_2.forEach((item) => {
        Object.entries(item).forEach((a) => {
          obj__.push(a[1]);
        });
      });

      obj__.forEach((item2) => {
        item2.forEach((item3) => {
          obj2__.push({ tagId: item3.tagId });
        });
      });

      var newdata = [];

      obj2__.forEach((item2) => {
        props.tag_values.forEach((item) => {
          if (item.tagId === item2.tagId) {
            const tagValue = parseFloat(item.tag_value).toFixed(2);

            newdata.push({
              tagId: item.tagId,
              tagValue: tagValue,
            });
          }
        });
      });

      console.log(newdata);

      Set_tag_values(newdata);
    };

    componentDidMount();
  }, []);

  const getBackgroundStyle = (type, valueString) => {
    const numericValue = parseFloat(valueString).toFixed(2);

    if (!maxValueByType.hasOwnProperty(type)) {
      return { background: "white" };
    }

    const maxValue = maxValueByType[type];
    const minValue = minValueByType[type] || 0;
    const adjustedValue = Math.max(numericValue - minValue, 0);
    const adjustedMaxValue = maxValue - minValue;
    const ratio = Math.min(Math.max(adjustedValue / adjustedMaxValue, 0), 1);
    if (type.includes("Çalışma Durumu")) {
      return {
        background: `linear-gradient(to right, rgb(76, 187, 23) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    } else if (type.includes("Arıza Durumu") || type.includes("Alarm")) {
      return {
        background: `linear-gradient(to right, 	rgb(255, 36, 0) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    }

    return {
      background: `linear-gradient(to right, rgb(237, 188, 69) ${
        ratio * 100
      }%, white ${ratio * 100}%)`,
    };
  };

  const loadingStyle = {
    background: "linear-gradient(to right, #f0f0f0 50%, white 50%)",
  };

  function splitValueAndUnit(value) {
    const valueWithDot = value.replace(",", ".");
    const matches = valueWithDot.match(/([0-9.]+)\s*(.*)/);
    if (matches) {
      return { number: parseFloat(matches[1]), unit: matches[2] };
    }
    return { number: parseFloat(valueWithDot), unit: "" };
  }

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <div className="energy2-page">
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <section className="section_energy">
        <Link to="/">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className=" movebuttons-energy"
            variant="contained"
          >
            Ana Ekran
          </Button>
        </Link>
        <div className="top">
          <div>ENERJİ ANALİZÖRLERİ</div>
        </div>
        <div className="buttonarea-energy">
          <Link className="buttons" to="/energy">
            Geri
          </Link>
          <Link className="buttons" to="/energy3">
            İleri
          </Link>
        </div>
        <div className="bottom">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              title.push(a[0]);
              obj_.push(a[1]);
            });

            console.log(obj_);
            // var değer =tag_values
            //     .filter(
            //         (x) => String(x.tagId) === String(item.elementDetails.tagId)
            //     )
            //     .map((a) => a.tagValue);
            return (
              <div className="rows">
                <div className="left">
                  <div></div>
                  <div className="lefttitle">{title[0]}</div>
                </div>
                <div className="right">
                  <div className="right_top">
                    {obj_[0].map((x, index) => {
                      function sondanIlkBosluktanSonrakiKisim(metin) {
                        if(metin!==undefined){

                        // Metni ters çevir
                        var tersMetin = metin.split("").reverse().join("");

                        // İlk boşluğun index'ini bul
                        var ilkBoslukIndex = tersMetin.indexOf(" ");

                        // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                        var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                        // İlk boşluğun index'inden sonraki kısmı al
                        var sonrakiKisim = metin.substring(orijinalIndex + 1);

                        return sonrakiKisim;
                        }
                      }
                      var değerler = props.energy_tags
                        .filter((a) => String(a.tagId) === String(x.tagId))
                        .map((b) => b.tagValue);
                      var değerler_eleman = değerler[0];
                      var unit =
                        sondanIlkBosluktanSonrakiKisim(değerler_eleman);
                      console.log(x);
                      return (
                        <div className="righttop">{x.text + ` (${unit})`}</div>
                      );
                    })}
                  </div>
                  <div className="right_bottom">
                    {obj_[0].map((x, index) => {
                      var değerler = props.energy_tags
                        .filter((a) => String(a.tagId) === String(x.tagId))
                        .map((b) => b.tagValue);

                      var değerler_eleman = değerler[0];

                      function sondanIlkBoslukIndexiniBul(metin) {
                        if (metin !== undefined) {

                        // Metni ters çevir
                        var tersMetin = metin.split("").reverse().join("");

                        // İlk boşluğun index'ini bul
                        var ilkBoslukIndex = tersMetin.indexOf(" ");

                        // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                        var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                        return orijinalIndex;
                        }
                      }
                      function metniIndexeKadarAl(metin, index) {
                        if(metin!==undefined){
                        // substring kullanarak
                        var metinSubstring = metin.substring(0, index);

                        // veya slice kullanarak

                        metinSubstring = String(metinSubstring);
                        metinSubstring = metinSubstring.replaceAll(",", ".");

                        metinSubstring = Number(metinSubstring).toFixed(2);

                        return metinSubstring;
                        }
                      }

                      function sondanIlkBosluktanSonrakiKisim(metin) {
                        // Metni ters çevir
                        var tersMetin = metin.split("").reverse().join("");

                        // İlk boşluğun index'ini bul
                        var ilkBoslukIndex = tersMetin.indexOf(" ");

                        // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                        var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                        // İlk boşluğun index'inden sonraki kısmı al
                        var sonrakiKisim = metin.substring(orijinalIndex + 1);

                        return sonrakiKisim;
                      }
                      var last_değer = metniIndexeKadarAl(
                        değerler_eleman,
                        sondanIlkBoslukIndexiniBul(değerler_eleman)
                      );
                      const matchingTag = props.tag_list.find(tag => tag.tagId === x.tagId);

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null
                            ? Number(matchingTag.tagDecimal)
                            : 2;



                          last_değer = decimalPlaces !== 0 ? Number(last_değer).toFixed(decimalPlaces) : Number(last_değer).toFixed(2)
                      if (x.text.includes("Çalışma Durumu")) {
                        console.log(last_değer, typeof last_değer);
                        if (String(last_değer) === "1.00 ") {
                          console.log(last_değer, "qwer");
                          last_değer = "ON";
                        } else {
                          last_değer = "OFF";
                        }
                      } else if (
                        x.text.includes("Arıza Durumu") ||
                        x.text.includes("Alarm")
                      ) {
                        if (String(last_değer) === "1.00 ") {
                          last_değer = "ALARM";
                        } else {
                          last_değer = "NORMAL";
                        }
                      } else {
                        function formatNumber(number) {
                          // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                          const parts = number.toString().split(".");
                          // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                          parts[0] = parts[0].replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            "."
                          );
                          // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                          if (parts[1]) {
                            parts[1] = parts[1].padEnd(2, "0");
                          } else {
                            parts.push("00");
                          }
                          // Parçaları birleştirip sonucu döndürme
                          return parts.join(",");
                        }
                        last_değer = formatNumber(last_değer);
                      }

                      return değerler.length > 0 ? (
                        değerler.map((değer) => (
                          <div
                            onContextMenu={(e) => {
                              e.preventDefault();
                              const { clientX, clientY } = e;
                              console.log(clientX, clientY);
                              var tagName = props.tag_list
                                .filter((b) => b.tagId === x.tagId)
                                .map((c) => c.tagName)[0];

                              document
                                .querySelector(".show_external_trend")
                                .classList.toggle("show_external_trend_active");
                              document.querySelector(".show_tagId").innerHTML =
                                x.tagId;
                              var popup = document.querySelector(
                                ".show_external_trend"
                              );
                              const popupRect = popup.getBoundingClientRect();
                              const viewportWidth = window.innerWidth;
                              const viewportHeight = window.innerHeight;

                              // Calculate the new positions
                              let newX = clientX;
                              let newY = clientY;

                              // Adjust if the popup would overflow the right edge of the viewport
                              if (newX + popupRect.width > viewportWidth) {
                                newX = viewportWidth - popupRect.width;
                              }

                              // Adjust if the popup would overflow the bottom edge of the viewport
                              if (newY + popupRect.height > viewportHeight) {
                                newY = viewportHeight - popupRect.height;
                              }

                              // Adjust if the popup would overflow the left edge of the viewport
                              if (newX < 0) {
                                newX = 0;
                              }

                              // Adjust if the popup would overflow the top edge of the viewport
                              if (newY < 0) {
                                newY = 0;
                              }

                              // Set the position of the popup
                              popup.style.left = `${newX}px`;
                              popup.style.top = `${newY}px`;
                              document.querySelector(
                                ".show_tagName"
                              ).innerHTML = tagName;
                            }}
                            style={getBackgroundStyle(x.text, değer)}
                          >
                            {last_değer}
                          </div>
                        ))
                      ) : (
                        <div
                          className={x.class + " rightbottom"}
                          style={loadingStyle}
                        >
                          {"Veri Yükleniyor"}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    user_id: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_list: state.project_reducer.tag_list,
    white_space_: state.project_reducer.white_space_items,
    fetch_tag_value_control: state.project_reducer.fetch_tag_value_control,
    energy_tags: state.project_reducer.energy_tags2,
  };
};
export default connect(MapStateToProps)(Energy2);
